const resolveApiUrl = (rawUrl) => {
  if (!rawUrl) {
    return rawUrl;
  }

  if (typeof window === "undefined") {
    return rawUrl;
  }

  try {
    const parsed = new URL(rawUrl);
    const isLocalApi =
      parsed.hostname === "localhost" ||
      parsed.hostname === "127.0.0.1";
    const isClientLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    if (isLocalApi && !isClientLocalhost) {
      parsed.hostname = window.location.hostname;
    }

    return parsed.toString().replace(/\/$/, "");
  } catch {
    return rawUrl;
  }
};

const API_URL = resolveApiUrl(process.env.REACT_APP_API_URL);
const API_VERSION = process.env.REACT_APP_API_VERSION;
const API_KEY = process.env.REACT_APP_API_KEY;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const API_NIT = process.env.REACT_APP_API_NIT;
const APP_ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";
const DB_ENV = APP_ENV === "production" ? "pro" : "dev";


//process.env.NODE_ENV === "development" ? "dev" : "pro";
const API_URL_BAC = process.env.REACT_APP_API_URL_BAC;
const URL_INSTAGRAM =
  "";
const URL_FACEBOOK = "";
const URL_TIKTOK = "";
const APP_VERSION = process.env.REACT_APP_VERSION;
const TERMS_AND_CONDITIONS_MD_PATH =
  process.env.PUBLIC_URL + "docs/terminos-condiciones.md";
const RETURN_POLICY_MD_PATH =
  process.env.PUBLIC_URL + "docs/politicas-de-devolucion.md";
const FAQ_MD_PATH = process.env.PUBLIC_URL + "docs/preguntas-frecuentes.md";
const STORES_LOCATION_MD_PATH = process.env.PUBLIC_URL + "docs/ubicaciones.md";

export {
  API_URL,
  API_VERSION,
  API_URL_BAC,
  API_KEY,
  API_TOKEN,
  API_NIT,
  URL_INSTAGRAM,
  URL_TIKTOK,
  URL_FACEBOOK,
  APP_VERSION,
  TERMS_AND_CONDITIONS_MD_PATH,
  RETURN_POLICY_MD_PATH,
  FAQ_MD_PATH,
  STORES_LOCATION_MD_PATH,
  APP_ENV,
  DB_ENV,
};
